<template>
  <div class="layout">
    <Layout>
      <Layout>
        <Header class="hea">
          <p class="p">数据查询</p>
          <Row class="row">
            <i-col span="18" class="col1">
              查询时间段：
              <RadioGroup v-model="button6" type="button" size="small" @on-change="showTime">
                <Radio label="200天"></Radio>
                <Radio label="今天"></Radio>
                <Radio label="1天"></Radio>
                <Radio label="1星期"></Radio>
                <Radio label="1个月"></Radio>
              </RadioGroup>
              <DatePicker
                type="datetime"
                v-model="start"
                :value="start"
                @on-change="changeStart"
                style="width: 14%;margin-left:5px;"
              ></DatePicker>
              <DatePicker
                type="datetime"
                v-model="end"
                :value="end"
                @on-change="changeEnd"
                style="width: 14%;margin-left:5px;"
              ></DatePicker>
              <Select
                v-model="model89"
                clearable
                style="width:20%;margin-left:5px;"
                placeholder="数据类型"
              >
                <Option
                  v-for="item in cityList"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
            </i-col>
            <i-col span="6" class="col1">
              <Button class="btn" @click="serCh">查询</Button>
              <!-- <Button class="btn">报表</Button> -->
              <!-- <Button class="btn">Excel</Button> -->
              <!-- <Button class="btn">删除</Button> -->
            </i-col>
            <!-- <i-col span="12" class="xia">
            
            </i-col>-->
          </Row>
          <p class="p" style="margin-top:10px;">精确查询</p>
          <Row class="row">
            <i-col span="24" class="col1">
              查询时间段：
              <DatePicker
                type="datetime"
                v-model="start1"
                :value="start1"
                @on-change="changeStart1"
                style="width: 14%;margin-left:5px;"
              ></DatePicker>
              <DatePicker
                type="datetime"
                v-model="end1"
                :value="end1"
                @on-change="changeEnd1"
                style="width: 14%;margin: 0 5px 0 5px;"
              ></DatePicker>
              <Select v-model="model8" clearable style="width:10%" placeholder="时段类型" class="shi">
                <Option
                  v-for="item in shiduan"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
              <Select v-model="model9" clearable style="width:10%" placeholder="分" class="shi">
                <Option
                  v-for="item in shijian"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
              <Input v-model="value12" placeholder="请输入" clearable style="width: 10%" class="shi" />
              <Button class="btn" @click="sreaCh">查询</Button>
              <Select v-model="modellei" clearable style="width:10%" class="shi">
                <Option
                  v-for="item in cityList1"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
              <!-- <Select v-model="model8" clearable style="width:10%" placeholder="累计" class="shi">
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
            <Select v-model="model8" clearable style="width:10%" placeholder="时段类型" class="shi">
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
              </Select>-->
            </i-col>
          </Row>
        </Header>
        <Content :style="{ minHeight: '100%'}">
          <Row class="row2">
            <i-col span="24" class="col2">
              <RadioGroup v-model="border1" @on-change="showwhat">
                <Radio label="初始值" border></Radio>
                <Radio label="2D图" border></Radio>
                <Radio label="全部数据" border></Radio>
                <Radio label="传感器图" border></Radio>
                <Radio label="相对位移" border></Radio>
                <Radio label="管理" border></Radio>
                <Radio label="3D立体图" border></Radio>
              </RadioGroup>
            </i-col>
          </Row>
          <Row class="row2">
            <i-col span="12" class="col3">
              <Card>
                <div>
                  <RadioGroup v-model="button4" type="button" size="small" @on-change="show">
                    <Radio label="XZ图"></Radio>
                    <Radio label="YZ图"></Radio>
                  </RadioGroup>
                  <Button @click="maxTu" style="float:right;">
                    <Icon type="ios-expand" />
                  </Button>
                  
                </div>
                <div style="min-height: 300px;" v-show="showX">
                  <div id="main32" style="width: 100%;height:360px;"></div>
                </div>
                <div style="min-height: 300px;" v-show="showY">
                  <div id="main33" style="width: 600px;height:360px;"></div>
                </div>
                <Spin fix v-show="spinShow" size="large"></Spin>
                <div style="margin-left:50px;font-size:26px">
                  初始时间：{{newTime}}
                </div>
              </Card>
              <Modal v-model="modal10" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main344" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
              <Modal v-model="modal11" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main333" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
            </i-col>
            <i-col span="12" class="col3">
              <Card style="margin-left:10px;">
                <div>
                  <RadioGroup v-model="button5" type="button" size="small" @on-change="showQ">
                    <Radio label="XZ图"></Radio>
                    <Radio label="YZ图"></Radio>
                  </RadioGroup>
                  <Button @click="maxTuright" style="float:right;">
                    <Icon type="ios-expand" />
                  </Button>
                </div>
                <div style="min-height: 385px;" v-show="showZ">
                  <div id="main44" style="width: 600px;height:360px;"></div>
                </div>
                <div style="min-height: 385px;" v-show="showYZ">
                  <div id="main22" style="width: 100%;height:360px;"></div>
                </div>
                <Spin fix v-show="spinShow1" size="large"></Spin>
              </Card>
              <Modal v-model="modal12" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main444" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
              <Modal v-model="modal13" footer-hide width="1300">
                <div style="min-height: 800px;">
                  <div id="main222" style="width:1200px;height:800px;"></div>
                </div>
              </Modal>
            </i-col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import echarts from "echarts";
import api from "@/api/aipause";
export default {
  data() {
    return {
      //单选
      button6: "",
      border: "初始值",
      button4: "XZ图",
      button5: "YZ图",
      modal3: false,
      border1: "初始值",
      single1: false,
      single2: false,
      single3: false,
      single4: false,
      //开始时间
      start: "",
      start1: "",
      end: "",
      end1: "",
      spinShow: true,
      spinShow1: true,
      formLeft: {
        senNum: "",
        senType:"",
        senName: "",
        senDesc: "",
        clientId : "",
      },
      //下拉列表
      cityList: [
        {
          value: "real",
          label: "实时值"
        },
        {
          value: "avg",
          label: "日平均值"
        },
        {
          value: "max",
          label: "日最大值"
        },
        {
          value: "min",
          label: "日最小值"
        }
      ],
      cityList1: [
        {
          value: "real",
          label: "累计"
        },
        {
          value: "avg",
          label: "简单累计"
        },
        {
          value: "max",
          label: "简单位移"
        }
      ],
      modellei: "real",
      shiduan: [
        {
          value: "时间段",
          label: "时间段"
        },
        {
          value: "指定值",
          label: "指定值"
        }
      ],
      shijian: [
        {
          value: "月",
          label: "月"
        },
        {
          value: "日",
          label: "日"
        },
        {
          value: "时",
          label: "时"
        },
        {
          value: "分",
          label: "分"
        }
      ],
      model8: "",
      model9: "",
      model89: "",
      modal10: false,
      modal11: false,
      modal12: false,
      modal13: false,
      //输入框
      value14: "",
      value12: "",
      shuju: [[0, 0, 0]],
      shuju2: [[0, 0, 0]],
      showX: true,
      showY: false,
      showZ: false,
      showYZ: true,
      newTime: "",
      allData: {},
      shuZ: [],
      shuX: [],
      shuY: [],
      liuWidth:"",
      c:{},
      unit:"",
      zData: [],
      initialValue:"",
      time:""
    };
  },
  methods: {
    //标签跳转
    showwhat($event) {
      //
      if ($event == "2D图") {
        this.$router.push({
          name: "2D_figure"
        });
      }
      if ($event == "初始值") {
        this.$router.push({
          name: "3D_diagram"
        });
      }
      if ($event == "全部数据") {
        this.$router.push({
          name: "allData"
        });
      }
      if ($event == "传感器图") {
        this.$router.push({
          name: "sensor_Figure"
        });
      }
      if ($event == "相对位移") {
        this.$router.push({
          name: "relative_Displacement"
        });
      }
      if ($event == "管理") {
        this.$router.push({
          name: "management"
        });
      }
      if ($event == "3D立体图") {
        this.$router.push({
          name: "3D_Stereogram"
        });
      }
    },
    switchTimeFormat(time) {
      const dateTime = new Date(time);
      const year = dateTime.getFullYear();
      const month = dateTime.getMonth() + 1;
      const date = dateTime.getDate();
      const hour = dateTime.getHours();
      const minute = dateTime.getMinutes();
      const second = dateTime.getSeconds();
      return `${year}-${this.addZero(month)}-${this.addZero(
        date
      )} ${this.addZero(hour)}:${this.addZero(minute)}:${this.addZero(second)}`;
    },
    addZero(v) {
      return v < 10 ? "0" + v : v;
    },
    maxTu(){
     
      if(this.button4 == "XZ图"){
        this.modal10 = true
        // this.liuWidth = document.body.clientWidth - 100
        setTimeout(()=>{
          this.leftXz44(this.shuju , this.unit)
        },500)  
      }
      if(this.button4 == "YZ图"){
        this.modal11 = true
        // this.leftYz333(this.shuju2);
        setTimeout(()=>{
          this.leftYz333(this.shuju2 , this.unit);
        },500) 
      }
    },
    maxTuright(){
      if(this.button5 == "XZ图"){
        this.modal12 = true
        setTimeout(()=>{
          // this.c = {
          //   width:"" + document.body.clientWidth - 100 + ""+"px",
          //   height:"" + document.body.clientHeight - 200 + ""+"px"
          // }
          this.rightYz444(this.shuju , this.unit);
        },500) 
      }
      if(this.button5 == "YZ图"){
        this.modal13 = true
        setTimeout(()=>{
          // this.c = {
          //   width:"" + document.body.clientWidth - 100 + ""+"px",
          //   height:"" + document.body.clientHeight - 200 + ""+"px"
          // }
          this.rightXz222(this.shuju2 , this.unit);
        },500) 
      }
    },
    //选择时间
    showTime($event) {
      if ($event == "1天") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "1星期") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 7 * 24 * 3600 * 1000); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "1个月") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.setMonth(curDate.getMonth() - 1)); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "200天") {
        localStorage.setItem("button6" , $event)
        let curDate = new Date();
        let preDate = new Date(curDate.getTime() - 200 * 24 * 3600 * 1000); //前一天
        this.changeStart(this.switchTimeFormat(preDate));
        this.changeEnd(this.switchTimeFormat(new Date()));
      }
      if ($event == "今天") {
        localStorage.setItem("button6" , $event)
        let start = new Date(
          new Date(new Date().toLocaleDateString()).getTime()
        );
        let end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.changeStart(this.switchTimeFormat(start));
        this.changeEnd(this.switchTimeFormat(end));
      }
      //
    },
    show($event) {
      if ($event == "YZ图") {
        // alert(1)
        this.leftXz()
        this.leftYz(this.shuju2,this.unit);
        this.showX = false;
        this.showY = true;
      }
      if ($event == "XZ图") {
        // alert(1)
        this.leftXz(this.shuju,this.unit)
        this.leftYz();
        this.showX = true;
        this.showY = false;
      }
    },
    showQ($event) {
      if ($event == "XZ图") {
        // alert(1)
        this.rightXz();
        this.rightYz(this.shuju,this.unit);
        this.showYZ = false;
        this.showZ = true;
      }
      if ($event == "YZ图") {
        // alert(1)
        this.rightYz();
        // this.rightXz();
        this.rightXz(this.shuju2,this.unit);
        this.showYZ = true;
        this.showZ = false;
      }
    },
    //精确查询
    sreaCh() {
      if (this.start1 !== "" || this.end1 !== "") {
        if (!this.model8) return this.$Message.error("请选择时段类型");
        if (this.model8 == "时间段") {
          localStorage.setItem("start", this.start1);
          localStorage.setItem("end", this.end1);
          this.$router.push({
            path: "/engineering/allData",
            query: {
              name: "1",
              shiduan: this.model8,
              shijian: this.model9,
              jinTime: this.value12
            }
          });
        } else if (this.model8 == "指定值") {
          if (this.start1 !== "") {
            localStorage.setItem("start", this.start1);
            // localStorage.setItem("end", this.end1);
            this.$router.push({
              path: "/engineering/allData",
              query: {
                name: "1",
                shiduan: this.model8,
                shijian: this.model9,
                jinTime: this.value12
              }
            });
          } else if (this.end1 !== "") {
            this.$Message.error("指定时间只能选择开始时间，不能选择结束时间");
            // localStorage.setItem("start", this.start1);
            // // localStorage.setItem("end", this.end1);
            // this.$router.push({
            //   path: "/engineering/allData",
            //   query: {
            //     name: "1",
            //     shiduan: this.model8,
            //     shijian: this.model9,
            //     jinTime: this.value12
            //   }
            // });
          }
        }
      } else {
        if (!this.model8) return this.$Message.error("请选择时段类型");
        // this.getMenu();
        localStorage.setItem("start", "");
        localStorage.setItem("end", "");
        this.$router.push({
          path: "/engineering/allData",
          query: {
            name: "1",
            shiduan: this.model8,
            shijian: this.model9,
            jinTime: this.value12
          }
        });
      }
      // if(this.start1 == "" || this.end1 == ""){
      //   if (!this.model8) return this.$Message.error("请选择时段类型");
      // }else {
      //   this.getMenu();
      // }
    },
    serCh() {
      this.start = this.switchTimeFormat(this.start);
      this.end = this.switchTimeFormat(this.end);
      localStorage.setItem("start1" , this.start)
      localStorage.setItem("end1" , this.end)
      localStorage.setItem("dataType" , this.model89)
      //
      // if (!this.start) return this.$Message.error("请选择开始时间");
      // if (!this.end) return this.$Message.error("请选择开始时间");
      if (this.start == "" && this.end == "") {
        if (this.model89 !== "") {
          this.allData = {
            dirId: localStorage.getItem("deviceId"),
            // start: localStorage.getItem("start"),
            // end: localStorage.getItem("end")
            statistic: this.model89
          };
        }
      } else if (!this.start) {
        return this.$Message.error("请选择开始时间");
      } else if (!this.end) {
        return this.$Message.error("请选择结束时间");
      } else if (this.start !== "" && this.end !== "") {
        if (this.model89 !== "") {
          this.allData = {
            dirId: localStorage.getItem("deviceId"),
            start: "" + this.start + "",
            end: "" + this.end + "",
            statistic: this.model89
          };
        } else {
          return this.$Message.error("请选择数据类型");
        }
      }
      this.$Message.loading({
        content: "正在获取数据请稍候..",
        duration: 3
      });
      this.shuju = [];
      this.shuju2 = [];
      api("post", "queryPage", {
        // dirId: localStorage.getItem("deviceId"),
        // start: "" + this.start + "",
        // end: "" + this.end + ""
        ...this.allData
      }).then(res => {
        let data = res.data;
       
        if (data.code === 0) {
          for (let i = 0; i < data.incline.length; i++) {
            this.shuju.push([data.incline[i].x, data.incline[i].z]);
          }
          for (let i = 0; i < data.incline.length; i++) {
            this.shuju2.push([
              data.incline[i].y,
              data.incline[i].z,
              data.incline[i].depth
            ]);
          }
          this.unit = data.unit
          if(this.shuju2.length == 0 && this.shuju.length == 0){
            this.$Message.success("暂无数据");
          }else{
            this.$Message.success("搜索成功");
            // this.shuju.push([0, 0, 0]);
            // this.shuju2.push([0, 0, 0]);
            this.rightXz(this.shuju2,this.unit);
            this.leftYz(this.shuju2,this.unit);
            this.leftXz(this.shuju,this.unit);
            this.rightYz(this.shuju,this.unit);
          }
          
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    //开始时间
    changeStart(data) {
      this.start = data;
      localStorage.setItem("start1" , this.start)
    },
    //结束时间
    changeEnd(data) {
      this.end = data;
      localStorage.setItem("end1" , this.end)
    },
    //开始时间
    changeStart1(data) {
      this.start1 = data;
    },
    //结束时间
    changeEnd1(data) {
      this.end1 = data;
    },
    leftXz(e,unit) {
     console.error(e)
      var myChart123 = echarts.init(document.getElementById("main32"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "X",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },
        series: [
          {
            name: this.newTime,
            color: "red",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart123.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart123.resize();
      });
    },
    leftXz44(e,unit) {
      var myChart1 = echarts.init(document.getElementById("main344"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "X",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },
        series: [
          {
            name: this.newTime,
            color: "red",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart1.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart1.resize();
      });
    },
    rightXz(e,unit) {
      var myChart332 = echarts.init(document.getElementById("main22"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "Y",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },

        series: [
          {
            name: this.newTime,
            color: "green",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart332.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart332.resize();
      });
    },
    rightXz222(e,unit) {
      var myChart3 = echarts.init(document.getElementById("main222"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "Y",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },

        series: [
          {
            name: this.newTime,
            color: "green",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart3.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart3.resize();
      });
    },
    leftYz(e,unit) {
      var myChart213 = echarts.init(document.getElementById("main33"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "Y",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },

        series: [
          {
            name: this.newTime,
            color: "green",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart213.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart213.resize();
      });
    },
    leftYz333(e,unit) {
      var myChart2 = echarts.init(document.getElementById("main333"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "Y",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },

        series: [
          {
            name: this.newTime,
            color: "green",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart2.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart2.resize();
      });
    },
    rightYz(e,unit) {
      var myChart415 = echarts.init(document.getElementById("main44"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "X",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },
        series: [
          {
            name: this.newTime,
            color: "red",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart415.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart415.resize();
      });
    },
    rightYz444(e,unit) {
      var myChart4 = echarts.init(document.getElementById("main444"));
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true
            // start: 10,
            // end: 50
          }
        ],
        xAxis: {
          name: "X",
          type: "value",
          // min: -100,
          // max: 100
        },
        yAxis: {
          name: "Z 单位" + unit,
          type: "value",
          // min: 0,
          // max: this.getMax(this.zData)
        },
        series: [
          {
            name: this.newTime,
            color: "red",
            symbolSize: 6,
            data: e,
            type: "line"
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart4.setOption(option, true);
      window.addEventListener("resize", () => {
        myChart4.resize();
      });
    },
    getMax(abc) {
      // 1.要深拷贝数组
      abc = abc.slice(0);
      // 2.排序（升序第一个值是最小值，降序第一个值是最大值）
      abc.sort(function(a, b) {
        return b - a;
      });
      // 3.返回第一个值
      return abc[0];
    },
    getMenu() {
      this.$Message.loading({
        content: "正在获取数据请稍候..",
        duration: 2
      });
      //
      this.model89 = localStorage.getItem("dataType") == null ? "real" : localStorage.getItem("dataType");
      api("post", "queryPage", {
        dirId: localStorage.getItem("deviceId"),
        statistic: "real"
      }).then(res => {
        let data = res.data;
       
        if (data.code === 0) {
          this.newTime = data.incline[0].created;
          for (let i = 0; i < data.incline.length; i++) {
            this.shuju.push([data.incline[i].x, data.incline[i].z]);
            this.zData.push(data.incline[i].z);
          }
          for (let i = 0; i < data.incline.length; i++) {
            this.shuju2.push([data.incline[i].y, data.incline[i].z]);
          }
          // this.shuju.push([0, 0, 0]);
          // this.shuju2.push([0, 0, 0]);
          this.unit = data.unit
          if(this.shuju == "" && this.shuju2 == ""){
            this.spinShow1 = false
            this.spinShow = false
          }else{
            this.spinShow1 = false
            this.spinShow = false
          }
          this.rightXz(this.shuju2,this.unit);
          // this.leftYz(this.shuju2,this.unit);
          this.leftXz(this.shuju,this.unit);
          // this.rightYz(this.shuju,this.unit);
        } else {
          this.shuju = [];
          this.shuju2 = [];
          this.rightXz();
          this.leftYz();
          this.leftXz();
          this.rightYz();
          this.spinShow1 = false
          this.spinShow = false
          this.$Message.error(data.msg);
        }
      });
    },
    getInitialValue() {
      api("GET", "getOriginalValues", {},localStorage.getItem("deviceId")).then(res => {
        let data = res.data;
        if (data.code === 0 &&  data.list.length>0) {

          this.newTime = data.list[0].created;
          for (let i = 0; i < data.list.length; i++) {
            this.shuju.push([data.list[i].coordiSumx, data.list[i].coordiSumz]);
            this.zData.push(data.list[i].coordiSumz);
          }
          for (let i = 0; i < data.list.length; i++) {
            this.shuju2.push([data.list[i].coordiSumy, data.list[i].coordiSumz]);
          }
          // this.shuju.push([0, 0, 0]);
          // this.shuju2.push([0, 0, 0]);
          this.unit = "mm"
          if(this.shuju == "" && this.shuju2 == ""){
            this.spinShow1 = false
            this.spinShow = false
          }else{
            this.spinShow1 = false
            this.spinShow = false
          }
          this.rightXz(this.shuju2,this.unit);
          this.leftYz(this.shuju2,this.unit);
          this.leftXz(this.shuju,this.unit);
          this.rightYz(this.shuju,this.unit);
        } else {
          this.shuju = [];
          this.shuju2 = [];
          this.rightXz();
          this.leftYz();
          this.leftXz();
          this.rightYz();
          this.spinShow1 = false
          this.spinShow = false
          this.$Message.error(data.msg);
        }
      });
    }
  },
  mounted() {
    this.spinShow1 = true
    this.spinShow = true
    this.button6 = localStorage.getItem("button6") == null ? "1天" : localStorage.getItem("button6")
    localStorage.setItem("button6" , this.button6)
    let curDate = new Date();
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
    this.changeStart(this.switchTimeFormat(preDate));
    this.changeEnd(this.switchTimeFormat(new Date()));
    // this.getMenu();
    this.getInitialValue()
   
  },
  watch:{
    "$route.params.id"() {
      this.spinShow1 = true
      this.spinShow = true
      this.getInitialValue();
    },
    model89(){
      localStorage.setItem("dataType" , this.model89)
    }
  }
};
</script>
<style scoped>
.layout {
  overflow: hidden;
  height: 100%;
}
.row2 {
  margin-top: 10px;
}
.row {
  color: #000;
  background-color: darkgrey;
  width: 100%;
}

.row1 {
  /* margin-top: 10px; */
  width: 100%;
  color: #000;
  background-color: darkgrey;
}
.hea {
  background-color: #fff;
  height: 100%;
  padding: 0;
}
.p {
  width: 60px;
  height: 18px;
  line-height: 19px;
  background-color: darkgrey;
  padding-left: 2px;
}
.btn {
  margin-right: 5px;
}
.xia {
  height: 50px;
  line-height: 50px;
  /* margin-left: 10px; */
}
.col1 {
  /* height:50px; */
  line-height: 50px;
}
.shi {
  margin-right: 5px;
}
.col2 {
  background-color: darkgrey;
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
}
content {
  height: 100%;
}
.col3 {
  height: 500px;
}

</style>